// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__Or4HK","carouselItem":"Carousel_carouselItem__gsgD-"};